import React from "react";
import List from "@material-ui/core/List";
import ListSubheader from "@material-ui/core/ListSubheader";
// import * as PropTypes from "prop-types";
import { withStyles } from "@material-ui/styles";
import {
  incomeGroupsList,
  donorGroupsList,
  regionalGroupsList
} from "./countryGroupsLists";
import CountryGroupsItem from "./CountryGroupsItem";
import styleConstants from "../../styleConstants";

const styles = {
  listContainer: {
    margin: "0 2rem",
    "& li": {
      padding: 0
    }
  },
  listSubheader: {
    color: styleConstants.colors.gray5,
    fontSize: "0.75rem",
    textTransform: "uppercase"
  }
};

const CountryGroupsTree = props => {
  const incomeGroups = incomeGroupsList.map((obj, index) => (
    <CountryGroupsItem
      key={index}
      heading={obj.heading}
      countries={obj.countries}
    />
  ));
  const donorGroups = donorGroupsList.map((obj, index) => (
    <CountryGroupsItem
      key={index}
      heading={obj.heading}
      countries={obj.countries}
    />
  ));
  const regionalGroups = regionalGroupsList.map((obj, index) => (
    <CountryGroupsItem
      key={index}
      heading={obj.heading}
      countries={obj.countries}
    />
  ));
  return (
    <List className={props.classes.listContainer}>
      <ListSubheader
        className={props.classes.listSubheader}
        disableSticky={true}
      >
        Income
      </ListSubheader>
      {incomeGroups}
      <ListSubheader
        className={props.classes.listSubheader}
        disableSticky={true}
      >
        Donor Priority
      </ListSubheader>
      {donorGroups}
      <ListSubheader
        className={props.classes.listSubheader}
        disableSticky={true}
      >
        Regional
      </ListSubheader>
      {regionalGroups}
    </List>
  );
};

export default withStyles(styles)(CountryGroupsTree);
